import React, { useEffect } from 'react'
import styled from 'styled-components/native'
import I18n from 'APP/I18n'
import Analytics from 'APP/Services/Analytics'
import Button from 'APP/Converse/Button'
import Typography from 'APP/Converse/Typography'
import BottomDrawer from 'APP/Converse/BottomDrawer'

const ContentContainer = styled.View`
  gap: ${({ theme }) => theme.metrics.baseMargin}px;
`

const Subtitle = styled(Typography)`
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
`

const PromptNewTargetModal = ({
  isVisible,
  currentTarget,
  newTarget,
  onClose,
  onAccept,
  onDecline,
}: {
  isVisible: boolean
  currentTarget: number
  newTarget: number
  onClose: () => void
  onAccept: () => void
  onDecline: () => void
}) => {
  const isIncreasePrompted = currentTarget < newTarget
  const i18nKey = isIncreasePrompted ? 'increase' : 'decrease'

  useEffect(() => {
    if (isVisible) {
      Analytics.trackScreen('New target prompt')
    }
  }, [isVisible])

  return (
    <BottomDrawer
      isVisible={isVisible}
      onClose={onClose}
      title={I18n.t(`ActiveMinutes.promptNewTarget.title.${i18nKey}`)}
      testID="NEW_TARGET_PROMPT_MODAL"
    >
      <ContentContainer>
        <Subtitle variant="bodyNormal">
          {I18n.t(`ActiveMinutes.promptNewTarget.copy.${i18nKey}`, { newTarget })}
        </Subtitle>
        <Button
          variant="primary"
          widthVariant="full"
          title={I18n.t('ActiveMinutes.promptNewTarget.accept')}
          onPress={onAccept}
          testID="ACCEPT_NEW_TARGET_BTN"
          analyticsName="AcceptNewTarget"
        />
        <Button
          variant="secondary"
          widthVariant="full"
          title={I18n.t('ActiveMinutes.promptNewTarget.decline')}
          onPress={onDecline}
          testID="KEEP_CURRENT_TARGET_BTN"
          analyticsName="KeepCurrentTarget"
        />
      </ContentContainer>
    </BottomDrawer>
  )
}

export default PromptNewTargetModal
